import clsx from 'clsx';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { getFormFieldProps, getFormFieldWrapperProps } from '@/formbuilder/formbuilder.utilities';
import { SelectColumnFromTablePure } from '@/tableDefinitionEditor/SelectColumnFromTablePure.atom';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import type { ColumnDefinition } from '@/tableDefinitionEditor/tableDefinition.types';
import type { ColumnTypeEnum } from '@seeqdev/api/model/ColumnDefinitionInputV1';

export interface SelectColumnFromTableFormComponentProps extends ValidatingFormComponent<ColumnDefinition> {
  component: 'SelectColumnFromTableFormComponent';
  columns?: ColumnDefinition[];
  selectedColumnId?: string;
  onChange: (column?: ColumnDefinition) => void;
  allowedColumnTypes?: ColumnTypeEnum[];
  testId?: string;
  disabled?: boolean;
  isClearable?: boolean;
  isSearchable?: boolean;
  allowedColumnsFilter?: (column: ColumnDefinition) => boolean;
}

export const SelectColumnFromTableFormComponent = (props: SelectColumnFromTableFormComponentProps) => {
  const {
    name,
    validation,
    testId = 'selectColumnFromTable',
    wrapperClassNames,
    customErrorText,
    columns,
    selectedColumnId,
    onChange,
    allowedColumnTypes,
    disabled = false,
    isClearable = true,
    isSearchable = true,
    allowedColumnsFilter,
  } = props;

  const defaultValidation = _.isEmpty;
  const formState = useForm().getState();
  const showError =
    _.has(formState.errors, name) &&
    formState.hasValidationErrors &&
    (formState.modified?.[name] || formState.submitFailed);

  return (
    <FormFieldWrapper
      {...getFormFieldWrapperProps(props, ['wrapperClassNames', 'testId'])}
      testId={testId}
      wrapperClassNames={clsx('flexFill', wrapperClassNames)}
      showError={showError}
      customErrorText={customErrorText}>
      <Field name={name} validate={validation || defaultValidation}>
        {({ input, meta }) => {
          const formFieldProps = getFormFieldProps(formState, input, meta, props);
          return (
            <SelectColumnFromTablePure
              testId={`${testId}Field`}
              showError={formFieldProps.showError}
              onChange={(column) => {
                formFieldProps.onChange(column?.id);
                onChange?.(column);
              }}
              columns={columns ?? []}
              selectedColumnId={selectedColumnId}
              allowedColumnTypes={allowedColumnTypes}
              disabled={disabled}
              isClearable={isClearable}
              isSearchable={isSearchable}
              allowedColumnsFilter={allowedColumnsFilter}
              label="" // Don't show label - FormFieldWrapper already shows it
            />
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};
